module.exports = __webpack_public_path__ + "static/media/heart.d1b3edc3.svg";